<div mat-dialog-container>
    <div class="mat-dialog-header-content">
      <mat-icon class="{{'icon' + data.messageType + '-icon'}}">{{icons[data.messageType].icon}}</mat-icon>
    </div>
    <mat-radio-group
    aria-labelledby="example-radio-group-label"
    class="example-radio-group"
    [(ngModel)]="choice">
    <mat-radio-button class="example-radio-button" *ngFor="let choice of choices" [value]="choice">
      {{choice}}:
    </mat-radio-button>
  </mat-radio-group>
  
  <div *ngIf="choice=='Mensaje predeterminado' || choice=='Default message'">
  <h3>{{ 'COURSES.PUSHMSGDEFAULT' | translate}}</h3>
    <h4>{{ 'DIALOGMESSAGECOURSE.PUSHDEFAULTMSG' | translate}}</h4>
  </div>
  <div *ngIf="choice=='Escribir mensaje' || choice=='Write message'">
    <div class="mat-dialog-header-content">
      <h3>{{data.messageTitle}}</h3>
    </div>
    
    <mat-dialog-content>
      <mat-card class="form-section mat-elevation-z0">
        <form [formGroup]="pushMessageForm">
          <mat-form-field appearance="outline" class="mat-dialog-content">
            <mat-label>{{ 'COURSES.PUSHTITLE1' | translate}}</mat-label>
            <input type="text" #input placeholder="Deja en blanco para enviar un mensaje por defecto" aria-label="Deja en blanco para enviar un mensaje por defecto" matInput formControlName="pushMessage" maxlength="150"> 
            <mat-hint align="end">{{input.value?.length || 0}}/150</mat-hint>
          </mat-form-field>
        </form>
      </mat-card>
    </mat-dialog-content>
  </div>
    <div mat-dialog-actions align="end">
      <button mat-flat-button color="primary" [mat-dialog-close]="pushMessageForm.get('pushMessage').value"
        cdkFocusInitial>{{'PROFILE.ACCEPT'|translate}}</button>
      <button mat-flat-button *ngIf="data.messageType === 'question' || data.messageType === 'warning'" color="accent"
        [mat-dialog-close]="false" (click)="closeMe()">{{'PROFILE.CANCEL'|translate}}</button>
      <button mat-flat-button *ngIf="data.messageType !== 'question' && data.messageType !== 'warning'" color="primary"
        [mat-dialog-close]="true" (click)="closeMe()">{{'PROFILE.CLOSE'|translate}}</button>
    </div>
  </div>